import { Provider } from 'react-redux';
import type { AppProps } from 'next/app';
import UnionApp from '@xo-union/nextjs/app';
import Head from 'next/head';
import { initAnalytics } from '@/app/analytics/events';
import '@/app/helpers/patchReactLinesEllipsisUnmount';
import { Layout } from '@/app/components/Layout';
import '@xo-union/tk-ui-essentials';
import '@/app/styles/global.module.scss';
import store from '@/redux/store';

initAnalytics();

interface CustomPageProps {
  title?: string;
  hideHeader?: boolean;
  hideFooter?: boolean;
  hideAds?: boolean;
}

export default function App({ Component, pageProps }: AppProps<CustomPageProps>) {
  return (
    <>
      <Head>
        <title>{pageProps.title || 'Wedding Planning Checklist - The Knot'}</title>
      </Head>
      <UnionApp>
        <Provider store={store}>
          <Layout
            hideHeader={pageProps.hideHeader}
            hideFooter={pageProps.hideFooter}
            hideAds={pageProps.hideAds}
          >
            <Component {...pageProps} />
          </Layout>
        </Provider>
      </UnionApp>
    </>
  );
}
